import { render, staticRenderFns } from "./ExcluirModal.vue?vue&type=template&id=46d9c4ea&"
import script from "./ExcluirModal.vue?vue&type=script&lang=js&"
export * from "./ExcluirModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports